import React from 'react';

const EducationalContentContinueButton = ({
  hideNavigation,
  onContinue,
  buttonLabel,
  disabled = false,
}) => {
  if (hideNavigation) {
    return null;
  }

  const buttonClass = `primaryButton w-100 mb-10 fs-18 ${disabled ? "disable" : "cursor-pointer"}`;

  return (
    <div className="mx-auto p-0">
      <button
        type="button"
        className={buttonClass}
        onClick={onContinue}
        disabled={disabled}
        aria-disabled={disabled}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default EducationalContentContinueButton;

const EducationalContentSecondaryButton = ({
  hideNavigation,
  onContinue,
  buttonLabel,
  disabled = false,
}) => {
  if (hideNavigation) {
    return null;
  }
  const buttonClass = `secondaryButton contentSecondaryButton w-100 mb-10 fs-18 ${disabled ? "disable" : "cursor-pointer"}`;

  return (
    <div className="mx-auto p-0">
      <button
        type="button"
        className={buttonClass}
        onClick={onContinue}
        disabled={disabled}
        aria-disabled={disabled}

      >
        {buttonLabel}
      </button>
    </div>
  );
};

const EducationalContentTertiaryButton = ({
  hideNavigation,
  onContinue,
  buttonLabel,
  disabled = false,
}) => {
  if (hideNavigation) {
    return null;
  }
  const buttonClass = `secondaryButton contentTertiaryButton w-100 mb-10 fs-18 ${disabled ? "disable" : "cursor-pointer"}`;

  return (
    <div className="mx-auto p-0">
      <button
        type="button"
        className={buttonClass}
        onClick={onContinue}
        disabled={disabled}
        aria-disabled={disabled}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export { EducationalContentContinueButton, EducationalContentSecondaryButton, EducationalContentTertiaryButton };